import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import { getBusinessManagerSettings } from 'api/business-manager-settings/get/get';


const ACTIONS = createAsyncActions('SERVER.BUSINESS-MANAGER-SETTINGS.GET');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


export default function () {
  return function (dispatch) {
    dispatch(START());

    return getBusinessManagerSettings()
      .then(result => {
        dispatch(SUCCESS({}, result));
        return result;
      })
      .catch(reason => {
        dispatch(FAIL(null, null, {
          analytics: { type: 'error', payload: { name: 'shared.vod-settings.get' } },
        }));
        return Promise.reject(reason);
      });
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/business-manager-settings/business-manager-settings.js